import React, { useEffect, useState } from "react";
import { getUsersLight } from "../../api/user.api";
import {
  Box,
  Button,
  Divider,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useAuth } from "../../context/auth.context";
import { getRanking, updateRanking } from "../../api/ranking.api.js";
import { getActiveEvent } from "../../api/event.api.js";
import UserCard from "../../components/cards/user.card.js";
import { useSnackbar } from "../../context/snackbar.context.js";
import { useWebSocket } from "../../context/websocket.context.js";

const RankingPage = () => {
  const auth = useAuth();
  const showSnackbar = useSnackbar();
  const websocket = useWebSocket();
  const [ranking, setRanking] = useState();
  const [users, setUsers] = useState();
  const [eventId, setEventId] = useState();
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    if (!websocket || !websocket.message) {
      return;
    }
    if (websocket.message.Type !== "Ranking") {
      return;
    }
    setRefresh((prev) => !prev);
  }, [websocket]);

  useEffect(() => {
    getActiveEvent().then((response) => {
      setEventId(response.data.id);
      getRanking(response.data.id).then((response) => {
        setRanking(response.data);
      });

      getUsersLight(response.data.participants).then((response) => {
        setUsers(response.data);
      });
    });
  }, [refresh]);

  const getMedalEmoji = (index) => {
    switch (index) {
      case 0:
        return "🥇";
      case 1:
        return "🥈";
      case 2:
        return "🥉";
      default:
        return index + 1;
    }
  };

  const handleUpdate = (user, increase) => {
    updateRanking(eventId, user.id, increase).then(() => {
      showSnackbar("Rank updated!", "success");
      setRefresh((prev) => !prev);
    });
  };

  return (
    <div>
      <Typography variant="h3" gutterBottom>
        Ranking
      </Typography>

      <Divider sx={{ mt: 1, mb: 1 }} />

      {ranking && users && (
        <TableContainer>
          <Table sx={{ width: 200 }}>
            <TableHead>
              <TableRow>
                <TableCell>Rank</TableCell>
                <TableCell>User</TableCell>
                <TableCell>Points</TableCell>
              </TableRow>
            </TableHead>
            {ranking && users && (
              <TableBody>
                {ranking.ranks
                  .sort((a, b) => b.rank - a.rank)
                  .map((rank, index) => (
                    <TableRow key={rank.participantId}>
                      <TableCell sx={{ width: 20 }}>
                        {getMedalEmoji(index)}
                      </TableCell>
                      <TableCell sx={{ width: 50 }}>
                        <UserCard
                          user={users.find(
                            (user) => user.id === rank.participantId
                          )}
                        />
                      </TableCell>
                      <TableCell sx={{ width: 50 }}>
                        <Box 
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                          }}
                        >
                          {rank.rank}
                          {auth && auth.user.role == "Admin" && (
                            <Stack sx={{ ml: 2 }}>
                              <Button
                                onClick={() =>
                                  handleUpdate(
                                    users.find(
                                      (user) => user.id === rank.participantId
                                    ),
                                    1
                                  )
                                }
                              >
                                +
                              </Button>
                              <Button
                                onClick={() =>
                                  handleUpdate(
                                    users.find(
                                      (user) => user.id === rank.participantId
                                    ),
                                    0
                                  )
                                }
                              >
                                -
                              </Button>
                            </Stack>
                          )}
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            )}
          </Table>
        </TableContainer>
      )}
    </div>
  );
};

export default RankingPage;
